
import { Component, Vue } from 'vue-property-decorator'
import { delMerchantsTag, getMerchantsTagList, TagListDto } from "@/api/customerManage";
import { Getter } from "vuex-class";

@Component({
  name: 'LabelSetting'
})
export default class LabelSetting extends Vue {
  tagList: TagListDto[] = []

  created () {
    this.getTagList()
  }

  getTagList () {
    getMerchantsTagList({}).then((res) => {
      this.tagList = res.data.tagList || []
    })
  }

  beforeClose ({ position, instance }) {
    switch (position) {
      case 'cell':
        break;
      case 'outside':
        instance.close();
        break;
    }
  }
  toAdd () {
    this.$router.push('/labelHandle')
  }

  delData (id: string) {
    this.$confirmDialog.show({
      okText: "确认",
      cancelText: "取消",
      tips: "删除此标签后，已标记此标签的客户将被移除此标签",
      onOk: () => {
        return this.delFunc(id);
      },
    });
  }

  delFunc (id: string) {
    const params = {
      tagId: id
    }
    delMerchantsTag(params).then(() => {
      this.$toast.success({
        message: '客户标签删除成功！',
        duration: 1000,
        onClose: () => {
          setTimeout(()=>{
            this.getTagList()
          },200)
        }
      })
    })
  }

  toEdit (e: any, data: TagListDto) {
    if (['setting-title','label-style','setting-list'].includes(e.target.className)) {
      this.$router.push({
        path: '/labelHandle',
        query: {
          op: 'edit',
          data: JSON.stringify(data)
        }
      })
    }
  }
}
